<template>
	<v-app id="change-password">
		<v-container fluid fill-height>
			<v-layout align-center justify-center>
				<v-flex xs12 sm8 md4>
					<v-card class="elevation-12" v-if="this.sent">
						<v-toolbar dark color="primary">
							<v-layout justify-center class="title">
								Zmieniono email i wysłano link weryfikacyjny
							</v-layout>
						</v-toolbar>
					</v-card>
					<v-card class="elevation-12" v-else>
						<v-toolbar dark color="primary">
							<v-toolbar-title>Ustaw nowy adres email</v-toolbar-title>
							<v-spacer></v-spacer>
							<v-btn
								icon
								large
								target="_blank"
								slot="activator"
							>
							</v-btn>
						</v-toolbar>
						<v-card-text>

							<v-text-field
								browser-autocomplete="off"
								prepend-icon="person"
								name="email"
								label="Nowy email"
								aria-label="email"
								for="setup-bidder-email-address-view-new-email"
								id="setup-bidder-email-address-view-new-email"
								v-model="formData.email"
								type="text"></v-text-field>

						</v-card-text>
						<v-card-actions>
							<v-spacer></v-spacer>
							<v-btn color="primary" @click="setUpNewEmail">Ustaw</v-btn>
						</v-card-actions>
					</v-card>
				</v-flex>
			</v-layout>
		</v-container>
	</v-app>
</template>

<script>
	import {Api} from "@/api";

	export default {
		name: "SetupBidderEmailAddressView",

		data() {
			return {
				formData: {
					email: "",
					token: "",
				},
				sent: false,
			};
		},

		methods: {
			setUpNewEmail() {
				Api.post(this, "/bidder/setup-new-email-address", this.formData, () => {
					this.sent = true;
				});
			},
		},

		beforeMount() {
			this.formData.token = this.$route.query.token;
			Api.get(this, "/bidder/bidder-exist?token=".concat(this.formData.token), response => {
				if (!response) {
					this.$router.push("/not-found");
				}
			});
		},
	};
</script>

<style scoped>

</style>
